import { PaginationState } from '@psyomics/ui-components';
import { useCallback, useState } from 'react';

import { useGetSubmittedReferralsQuery } from '../../generated/home';

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_INDEX = 0;

const useSubmittedReferrals = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const [{ data, fetching, error }, reexecuteQuery] = useGetSubmittedReferralsQuery({
    requestPolicy: 'cache-and-network',
    variables: {
      input: {
        pagedQuery: {
          offset: pagination.pageIndex * pagination.pageSize,
          pageSize: pagination.pageSize,
        },
      },
    },
  });

  const refetch = useCallback(() => reexecuteQuery({ requestPolicy: 'network-only' }), [reexecuteQuery]);

  const result = data?.getSubmittedReferrals;

  return {
    error,
    fetching,
    pagination,
    refetch,
    sessions: result?.sessions ?? [],
    setPagination,
    totalCount: result?.totalCount ?? 0,
  };
};

export { useSubmittedReferrals };
